'use strict';

var Marionette = require('backbone-marionette');
var Wreqr = require('./wreqr');
var ModalsCollection = require('./collections/modals');
var SystemLanguagesCollection = require('./collections/system-languages');
var CountriesCollection = require('./collections/countries');
var CurrenciesCollection = require('./collections/currencies');
var ScannersCollection = require('./collections/scanners');
var SystemLanguagesData = require('../../../data/system-languages.json');
var CountriesData = require('../../../data/countries.json');
var SubtypesCollection = require('./collections/subtypes');

/**
 * Module definition for the global module
 *
 * @category   Module
 * @module     global
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */
var GlobalModule = Marionette.Module.extend({
    startWithParent: true,

    /**
     * Collection for the currencies
     * @type {CurrenciesCollection}
     */
    currenciesCollection: null,

    /**
     * Collection that maintains the modal windows
     * @type {ModalsCollection}
     */
    modalsCollection: null,

    /**
     * Collection with supported system languages
     * @type {SystemLanguagesCollection}
     */
    systemLanguagesCollection: null,

    /**
     * Collection with all countries
     * @type {CountriesCollection}
     */
    countriesCollection: null,

    /**
     * Collection for the catalog subtypes
     * @type {SubtypesCollection}
     */
    subtypesCollection: null,

    /**
     * Is triggered once the module has been initilized
     * @param {string}      moduleName Name of this module
     * @param {Application} app        Instance of the app
     */
    initialize: function(moduleName, app) {
        // Load collections on login
        this.listenTo(app.vent, 'logged-in', function() {
            // Create countries collection
            this.countriesCollection = new CountriesCollection(CountriesData);

            // Fetch currencies
            app.loadData(this.currenciesCollection);

            if (app.user.get('licenseScanners')) {
                app.loadData(this.scannersCollection);
            }

            // Fetch catalog subtypes
            app.loadData(this.subtypesCollection);
        }.bind(this));
    },

    /**
     * Is triggered, once the app has started
     * @param {object} options
     */
    onStart: function(options) {
        // Create the modals collections
        this.modalsCollection = new ModalsCollection();

        // Create currencies collection
        this.currenciesCollection = new CurrenciesCollection();

        // Create rfid scanners collection
        this.scannersCollection = new ScannersCollection();

        // Create system languages collection
        this.systemLanguagesCollection = new SystemLanguagesCollection(SystemLanguagesData);

        // Create subtypes collection
        this.subtypesCollection = new SubtypesCollection();

        // Create wreqr
        this.wreqr = new Wreqr({
            app: this.app,
            module: this,
        });
    },
});

module.exports = GlobalModule;